// @flow
import React, { PureComponent } from 'react';

import BackgroundImage from 'components/fragments/BackgroundImage';
import Loading from 'components/fragments/Loading';

export type StateProps = {
    datas: Object,
    loading: boolean,
};

type Props = StateProps;

class TeamMenuPOTM extends PureComponent<Props>{

  render() {
    const { loading } = this.props;

    if (loading) {
      return (
        <div className="col col-md-6 col-lg-3 mb-2 mb-lg-0">
          <Loading />
        </div>
      );
    }

    return (
        this.props.datas &&
        <div className="col col-md-6 col-lg-3 mb-2 mb-lg-0">
          <a href={this.props.datas.joueur_du_mois.link} className="box card card--picture box--white">
            <BackgroundImage
                className="card__thumbnail img-blue"
                illustration={this.props.datas.joueur_du_mois.featured_image}
                srcset={this.props.datas.joueur_du_mois.srcset}
            />
            <div className="card__body">
                <h3 className="card__title">{this.props.datas.joueur_du_mois.nom}</h3>
                <p className="card__desc ft-h6 ft-up ft-truncat">Joueur du mois</p>
            </div>
            <div className="card__footer">
                <span className="link-chevron">Découvrir son profil<i className="icon icon-chevron-right"></i></span>
            </div>
          </a>
        </div>
    );
  }
};

export default TeamMenuPOTM;
